import { string, object } from 'yup';

export const editProfileSchema = object().shape({
  displayName: string().max(50, 'Maximum characters for a display name is 50'),
  biography: string().max(
    150,
    'Maximum characters for a biography name is 150'
  ),
  location: string().max(100, 'Maximum characters for a location is 100'),
  spotifyLink: string(),
  appleMusicLink: string(),
  youtubeLink: string(),
  website: string(),
});
